module.exports = __webpack_public_path__ + "static/media/img-fin-compra.a6b276b8.png";